import SimpleFormat from "./SimpleFormat";
import UserLink from "./UserLink";

export default {
  SimpleFormat,
  UserLink
};
